import { render, staticRenderFns } from "./ExpenseTable.vue?vue&type=template&id=9b66837e"
import script from "./ExpenseTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports